import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

/* =======================
   ASYNC THUNKS
======================= */

// Load Domains
export const fetchDomains = createAsyncThunk(
  "updateProfile4/fetchDomains",
  async (_, thunkAPI) => {
    try {
      const res = await agent.get(API.LOAD_DOMAINS_LIST);
      return res.data?.data || [];
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

// Load Objectives
export const fetchObjectives = createAsyncThunk(
  "updateProfile4/fetchObjectives",
  async (roleId, thunkAPI) => {
    try {
      const res = await agent.get(
        `${API.LOAD_ORGANIZATION_LIST_SIGNUP}/${roleId}/objective`
      );
      return res.data?.data || [];
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

/* =======================
   SLICE
======================= */

const updateProfile4Slice = createSlice({
  name: "updateProfile4",
  initialState: {
    domains: [],
    objectives: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearUpdateProfile3State(state) {
      state.domains = [];
      state.objectives = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* Domains */
      .addCase(fetchDomains.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDomains.fulfilled, (state, action) => {
        state.loading = false;
        state.domains = action.payload;
      })
      .addCase(fetchDomains.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* Objectives */
      .addCase(fetchObjectives.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchObjectives.fulfilled, (state, action) => {
        state.loading = false;
        state.objectives = action.payload;
      })
      .addCase(fetchObjectives.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearUpdateProfile4State } = updateProfile4Slice.actions;
export default updateProfile4Slice.reducer;
